import type { JSX } from 'react';
import { Seo } from '@/components/seo';
import { AvailabilityAlertsManager } from '@/components/dashboard/availabilityAlerts/AvailabilityAlertsManager';

export function DashboardAvailabilityAlerts(): JSX.Element {
  return (
    <section className="flex flex-col gap-xl py-8">
      <Seo
        title="Availability Alerts"
        description="Manage the email list for portfolio-wide availability status alerts."
        canonicalPath="/dashboard/availability-alerts"
        noIndex
      />

      <header className="flex flex-col gap-xs">
        <h1 className="text-2xl font-semibold text-brand-primary md:text-3xl">
          Availability Alerts
        </h1>
        <p className="text-sm text-text-primary/70">
          Manage the subscriber list. Notifications are queued when unit availability changes.
        </p>
      </header>

      <AvailabilityAlertsManager />
    </section>
  );
}
